import { render } from "./AchievementsActiveIcon.vue?vue&type=template&id=a5d86942"
import script from "./AchievementsActiveIcon.vue?vue&type=script&lang=js"
export * from "./AchievementsActiveIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__